import React from 'react';
import Social from './extras/Social';

const Footer = () => {
	const currentYear = () => {
		return new Date().getFullYear();
	};

	return (
		<footer className='footer'>
			<div className='footer__container'>
				<p>
					CARSO CNC <span>{currentYear()}&copy;</span>
				</p>
				<Social />
			</div>
		</footer>
	);
};

export default Footer;
